import { Component } from 'react'
import { Field } from 'redux-form'
import TextFieldWrapped from 'components/atoms/inputs/TextFieldWrapped'
import { resetPasswordStrengthActionCreator } from 'actions/authActions'
import * as debounce from 'lodash/debounce'
import { InjectedPasswordStrengthProps } from 'components/atoms/inputs/withPasswordStrength'

const PASSWORD_MIN_LENGTH = 8

export type PasswordFieldOwnProps = {
  label?: string
  name?: string
  autoComplete?: boolean
}

export type PasswordFieldDispatchProps = {
  getPasswordStrength: (password: string) => void
  resetPasswordStrength: typeof resetPasswordStrengthActionCreator
}

type PasswordFieldProps =
  & PasswordFieldDispatchProps
  & PasswordFieldOwnProps
  & InjectedPasswordStrengthProps

type PasswordFieldState = {
  isValid: boolean
}

class PasswordField extends Component<PasswordFieldProps, PasswordFieldState> {
  static defaultProps: Partial<PasswordFieldProps> = {
    label: 'Password',
    name: 'password',
  }

  state = {
    isValid: false,
  }

  render () {
    const { label, name, strengthNode, color, autoComplete } = this.props

    return (
      <>
        <Field
          component={ TextFieldWrapped }
          name={ name }
          validate={ this.validate }
          onChange={ this.handleChangeDebounced }
          props={{
            autoComplete: autoComplete ? autoComplete : 'new-password',
            label,
            type: 'password',
            qaMarker: 'password-input',
            color,
          }}
        />
        { this.state.isValid && strengthNode }
      </>
    )
  }

  componentWillUnmount () {
    this.handleChangeDebounced.cancel()
    this.props.resetPasswordStrength()
  }

  private validate = (value = '') => {
    const isValid = value.length >= PASSWORD_MIN_LENGTH

    this.setState({ isValid })

    return isValid
      ? undefined
      : `Please use ${ PASSWORD_MIN_LENGTH } or more characters`
  }

  private handleChange = (newValue: string) => {
    const { strengthNode, getPasswordStrength, resetPasswordStrength } = this.props

    if (!this.state.isValid) {
      if (strengthNode) {
        resetPasswordStrength()
      }

      return
    }

    getPasswordStrength(newValue)
  }

  private handleChangeDebounced = debounce(
    (_e: Event, newValue: string) => this.handleChange(newValue)
    , 150,
  )
}

export default PasswordField

